<template>
  <div class="activities">
    <div class="hero is-primary">
      <div class="hero-body" style="padding-top: 24px; padding-bottom: 24px;">
        <div class="container">
          <h1 class="title is-size-1" style="color: white !important;">Activity</h1>
          <h5 class="subtitle is-size-5" style="color: #bbb !important;">Scorecards submitted (last 10 days)</h5>        
        </div>
      </div>
    </div>
    <div class="container">
<!--
      <div v-if="ticker_data_round_robin != null">
        <VTextMarquee :speed="85">{{ ticker_data_round_robin.ticker}}</VTextMarquee>
      </div>

      <div v-if="ticker_data_solo != null">
        <VTextMarquee :speed="85">{{ ticker_data_solo.ticker}}</VTextMarquee>
      </div>
-->
      <br/>
      <div class="box" v-show="showError">
        <article class="message is-danger">
          <div class="message-body">
              {{ errorMessage }}
          </div>
        </article>
      </div>
      <div class="box">
        <div class="columns activity-header">
          <div class="column is-2">
            Date Time (UTC)
          </div>
          <div class="column is-2">
            Game
          </div>
          <div class="column is-3">
            Subscriber
          </div>
          <div class="column is-5">
            Options
            <br/><span style="font-size: 0.5em;">(Scorecard, Summary, Share, Email, CSV, delete)</span>
          </div>
        </div>
        <div v-if="pleaseWait"><p>Please wait...</p></div>
        <div v-for="(activity, index) in activities" :key="activity._id">
          <div class="columns activity">
            <div class="column is-2">
              <a v-on:click="showScorecard(activity)">
                <span class="is-size-7">{{ activity.dateTimeStamp | formatDateTime }}</span>
              </a>
            </div>
            <div class="column is-2">
              {{ activity.gameType }} <i title="Uploaded" class="fas fa-camera" v-if="activity.source == 'upload'"/>
              <br/><span v-if="activity.title != '' && activity.gameType != 'Solo'" class="is-size-7">({{ activity.title }})</span>
            </div>
            <div class="column is-3">
              <span class="is-size-7">{{ activity.subscriber }}</span>
            </div>
            <div class="column is-5">
              <div>
                <span v-if="activity.gameType == GameType.ROUNDROBIN || activity.gameType == GameType.TOURNAMENT">
                  <a class="is-size-4" v-on:click="showScorecard(activity)"><i class="fas fa-bullseye"></i></a>
                  &nbsp;
                  <a class="is-size-4" v-on:click="showSummaryModal(activity)"><i class="has-text-info fa-solid fa-clipboard-list"></i></a>
                  &nbsp;
                  <a class="is-size-4" title="Share Scorecard" v-on:click="shareScorecard(activity)"><i class="has-text-info fas fa-share"></i></a>
                  &nbsp;
                  <a class="is-size-4" title="Email Scorecard" v-on:click="emailScorecard(activity)"><i class="has-text-warning fas fa-envelope"></i></a>
                  &nbsp;
                  <a class="is-size-4" title="Email Scorecard" v-on:click="downloadCSV(activity)"><i class="has-text-success fas fa-file-csv"></i></a>
                </span> 
                <span v-if="activity.gameType == GameType.SOLO">
                  <a class="is-size-4" v-on:click="showScorecard(activity)"><i class="fas fa-bullseye"></i></a>
                </span>
                <span>
                  &nbsp;
                  <i class="is-size-4 fas fa-trash has-text-danger" v-on:click="deleteScorecard(activity, index)" title="DELETE"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br/>
      <br/>
    </div>
  </div>
</template>

<style>
.newLink {
  color: red;
  font-weight: bold;
}
</style>

<script>
import axios from "axios";
import { VTextMarquee } from 'vue-text-marquee';
import { GameType } from '@/enum/gameType.js';

export default {
  name: 'activity',
    components : {
      VTextMarquee: VTextMarquee
    },
    computed: {
    },
    data () {
      return {
        GameType,
        debugMode: (process.env.VUE_APP_DEBUG_MODE === "true" ? true : false),
        publicPath: process.env.BASE_URL,

        activities: [],
        errorMessage: '',
        showError: false,
        pleaseWait: true
      }
    },
    methods:{
      shareScorecard: function(scorecard) {
        this.$parent.shareScorecard(scorecard);
      },
      emailScorecard: function(scorecard) {
        this.$parent.emailScorecard(scorecard);
      },
      downloadCSV(scorecard) {
        this.$parent.downloadCSV(scorecard);
      },
      showScorecard: function(scorecard) {
        this.$parent.showScorecard(scorecard);
      },
      showSummaryModal: function(scorecard) {
        this.$parent.showNewSummaryModal(scorecard);
      },
      deleteScorecard: function(scoresheet, index) {
        if (confirm(`Are you sure you want to delete this scorecard submitted on ${scoresheet.dateTimeStamp} by ${scoresheet.subscriber}?`)) {
          const scorecardId = scoresheet._id;
          const url = this.$parent.getApiUrl(`scorecard/${scorecardId}`);
          const token = this.$parent.getApiToken();

          axios.delete(url, {
            headers: {
              authorization: token
            },
            data: {

            }
          })
          .then((response) => {
            this.activities.splice(index, 1);
          }, (error) => {
            if (this.debugMode) {
              console.log("Error deleting scorecard:", error);
            }
            alert("Error deleting scorecard.");
          });
          
        }
      },
      getActivities: function () {
        const url = this.$parent.getApiUrl('latestactivity/10');
        const token = this.$parent.getApiToken();
        axios.get(url,{
              headers: {
                  authorization: token
              }
          })
          .then((response) => {
            if (response.data.error != null) {
              this.errorMessage = response.data.error;
              this.showError = true;
              this.pleaseWait = false;
            } else {
              this.activities = response.data; 
              this.pleaseWait = false;
            }
          }, (error) => {
            this.errorMessage = error;
            this.showError = true;
            this.pleaseWait = false;
          });
        },
      isAdmin() {
        return this.$parent.isAdmin();
      }
    },
    mounted(){
      //console.log("process.env.VUE_APP_DEBUG_MODE: " + process.env.VUE_APP_DEBUG_MODE);
      if (this.isAdmin()) {
        setTimeout(() => {
          this.getActivities();
        }
          , 1000);
      } else {
        alert("You don't have permission to access this page.");
      }
    }
}
</script>

<style lang="scss">
.running {
  font-size: 6em !important;
  color: white;
}
</style>
<style lang="scss" scoped>
  .hero {
    background-color: #2e7d32;
    margin-bottom: 20px;
  }
  .box {
    font-family: inherit;
    background-color: #242424;
    color: white;
    border: 1px solid #444;
  }
  .activities {
    background-color: #181313;
    min-height: 100vh;
    color: white;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  }
  .activity-header {
    background-color: #333;
    color: white;
    font-size: 1.2em;
    border-radius: 6px;
    font-weight: bold;
    padding: 10px;
  }
  .activity {
    border-top: 1px solid #444;
    padding: 10px;
    color: #ddd;
    transition: background-color 0.2s;
  }
  .activity:hover {
    background-color: #2a2a2a;
  }
  .blink {
    color: #ffdd57;
    animation: blink-animation 1s steps(5, start) infinite;
    -webkit-animation: blink-animation 1s steps(5, start) infinite;
  }
  @keyframes blink-animation {
    to {
      visibility: hidden;
    }
  }
  @-webkit-keyframes blink-animation {
    to {
      visibility: hidden;
    }
  }
  a {
    color: #ffdd57;
  }
  a:hover {
    color: white;
  }
</style>